import { render, staticRenderFns } from "./SubscriptionPricing.vue?vue&type=template&id=2c93cac0&scoped=true"
import script from "./SubscriptionPricing.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionPricing.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SubscriptionPricing.vue?vue&type=style&index=0&id=2c93cac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c93cac0",
  null
  
)

export default component.exports